import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CssBaseline from '@mui/material/CssBaseline';
import {
    ThemeProvider as MuiThemeProvider,
    createTheme,
    StyledEngineProvider,
} from '@mui/material/styles';
// adding legacy styles to support theme if needed
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import ErrorBoundary from 'components/ErrorBoundary';
import Loader from 'components/Loader';
import ScrollToTop from 'components/ScrollToTop';
import Toaster from 'components/Toaster';
import { initialize as initializeDatadog } from 'helper/datadog';
import { GoogleConversionTracker } from 'providers';
import HubSpotTrackerScript from 'providers/HubSpotTracker';
import { PersistGate } from 'redux-persist/integration/react';
import Routes from 'route/route';

import initStore from 'redux/store';

import './index.css';

import reportWebVitals from './reportWebVitals';

const { store, persistor } = initStore;

initializeDatadog();

// Create a default theme
const theme = createTheme();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ErrorBoundary>
                <GoogleConversionTracker />
                <HubSpotTrackerScript />
                <StyledEngineProvider injectFirst>
                    <MuiThemeProvider theme={theme}>
                        <StylesThemeProvider theme={theme}>
                            <CssBaseline />
                            <BrowserRouter>
                                <ScrollToTop>
                                    <Routes />
                                </ScrollToTop>
                                <Loader />
                                <Toaster />
                            </BrowserRouter>
                        </StylesThemeProvider>
                    </MuiThemeProvider>
                </StyledEngineProvider>
                <ToastContainer />
            </ErrorBoundary>
        </PersistGate>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
